import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { accessInputFromRedux } from '@/abilities/accessInput';
import { useAccessInputFromQuery } from '@/abilities/useAccessInputFromQuery';
import { companyBankFeedAccess } from '@/abilities/companyBankFeed/access';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';
import { isAdminSelector } from '@/domain/env/envSelector';
import { useCompanyUserPreferences } from '@/domain/env/queries/companyUserPreferences';

export const useCompanyBankFeedAccess = () => {
  const companyId = useSelector(currentCompanyIdSelector);
  const isAdmin = useSelector(isAdminSelector);
  const bankFeedUserPermissions = useAccessInputFromQuery(useCompanyUserPreferences(companyId));
  return useMemo(
    () => companyBankFeedAccess({ isAdmin: accessInputFromRedux(isAdmin), bankFeedUserPermissions }),
    [isAdmin, bankFeedUserPermissions],
  );
};
